import { NgModule, ModuleWithProviders} from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { DefaultKeystoneAuthStorage, KeystoneAuthStorage} from './keystone-auth.storage';
import { HttpClientModule } from "@angular/common/http";
import { KeystoneHttpClient } from "./keystone-http-client.service";

export function keyStoneFactory(http, authStorage){
  return new KeystoneHttpClient(http, authStorage);
};


@NgModule({
  imports: [
    HttpClientModule
  ],
})
 export class KeystoneHttpModule{
  public static forRoot() : ModuleWithProviders {
    return {
      ngModule: KeystoneHttpModule,
      providers: [{ 
        provide: KeystoneAuthStorage,
        useClass: DefaultKeystoneAuthStorage
      },{ 
        provide: KeystoneHttpClient, 
        useFactory: keyStoneFactory,
        deps: [HttpClient, KeystoneAuthStorage]
      }]
    };
  }
}


// WEBPACK FOOTER //
// ./src/keystone-http/keystone-http.module.ts